// extracted by mini-css-extract-plugin
module.exports = {"signInForm":"SignInForm_signInForm__xuxV3","recaptchaError":"SignInForm_recaptchaError__qLdRg"};